const initModalResponse = () => {
    const modal = document.querySelector("[data-modal-response-form]");
    if (modal) {
        const closeModal = modal.querySelector("[data-close-icon]");
        closeModal.addEventListener('click', () => {
            modal.setAttribute("data-modal-response-form", "inactive");
        });
        const url = new URL(window.location.href);
        const modalResponse = url.searchParams.get("contact") === "1" || url.searchParams.get("download") === "1" || url.searchParams.get("eventSubscription") === "1";
        const errorResponse = url.searchParams.get("contact") === "0" || url.searchParams.get("download") === "0" || url.searchParams.get("eventSubscription") === "0" || url.searchParams.get("captchaError") === "1";
        if (modalResponse || errorResponse) {
            modal.removeAttribute("data-modal-response-form");
            if (modalResponse) {
                modal.setAttribute("data-modal-response-form", "success");
            }
            if (errorResponse) {
                modal.setAttribute("data-modal-response-form", "error");
            }
        }
    }
    const modalRemove = document.querySelector("[data-modal-response-form-remove]");
    if (modalRemove) {
        const closeModalRemove = modal.querySelector("[data-close-icon]");
        closeModalRemove.addEventListener('click', () => {
            modal.setAttribute("data-modal-response-form-remove", "inactive");
        });
        const url = new URL(window.location.href);
        const modalRemoveCheck = url.searchParams.get("contactremovecheck") === "1";
        const modalRemoveResponse = url.searchParams.get("contactremove") === "1";
        const modalRemoveErrorResponse = url.searchParams.get("contactremove") === "0" || url.searchParams.get("captcharemoveerror") === "1";
        if (modalRemoveCheck) {
            modal.removeAttribute("data-modal-response-form-remove");
            if (modalRemoveResponse) {
                modal.setAttribute("data-modal-response-form-remove", "success");
            }
            if (modalRemoveErrorResponse) {
                modal.setAttribute("data-modal-response-form-remove", "error");
            }
        }
    }
};
